import { Table } from "@mantine/core";
const modalContentData = {
  about: (
    <>
      <p>
        This map has limited functionality and not for planning purposes. The 3D
        map contains information relating applications sourced from My Port
        Phillip.
        <br /> <br />
        The applications that are represented have been provided with care, to
        ensure that data is accurate and current. However, some variations from
        records do exist, and complete accuracy cannot be guaranteed.
        Information, data and advice on this website is provided on the basis
        that site users undertake responsibility for assessing the relevance and
        accuracy of its content.
        <br /> <br /> The City of Port Phillip employees disclaim all liability
        for any error, loss or consequences which may arise from you relying on
        any information contained in this material.
        <br />
        <ul>
          <li>Information shown is indicative only</li>
          <li>Information last updated in September 2024</li>
        </ul>
<hr /> <br />
        The 3D map contains information on residential development applications
        lodged with the City of Port Phillip. The map only shows two application
        stages.
        <br />
        <br />
        <span style={{ textDecoration: "underline" }}>
          Applied For Permit is <span style={{ color: "#c85e19" }}>Orange</span>{" "}
          and Permit Approved is <span style={{ color: "#1a9798" }}>Teal</span>
        </span>
        <br />
        <br />
        We do not sponsor or endorse any material on websites linked from or to
        this website, including any social media websites that may be linked in
        any way to this website.
      </p>
      <br />
      <Table className="about-table">
        <thead>
          <tr>
            <th>Content</th>
            <th>Source</th>
            <th>Currency</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan={3} style={{ fontWeight: "bold" }}>
              Model Information
            </td>
          </tr>
          <tr>
            <td>
              <span style={{ textDecoration: "underline", color: "#c85e19" }}>
                Application Applied (Orange)
              </span>
            </td>
            <td>
              City of Port Phillip planning permits application repository, City
              of Port Phillip Development Activity Model
            </td>
            <td>Maximum of three months old</td>
          </tr>
          <tr>
            <td>
              <span style={{ textDecoration: "underline", color: "#1a9798" }}>
                Permit Approved (Teal)
              </span>
            </td>
            <td>
              City of Port Phillip planning permits application repository, City
              of Port Phillip Development Activity Model
            </td>
            <td>Maximum of three months old</td>
          </tr>
          <tr>
            <td colSpan={3} style={{ fontWeight: "bold" }}>
              Map
            </td>
          </tr>
          <tr>
            <td>Base map</td>
            <td>
              Open street map data represented through&nbsp;
              <a
                href="https://www.mapbox.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Mapbox
              </a>
              &nbsp;platform
            </td>
            <td>Updated by third party</td>
          </tr>
          <tr>
            <td>3D Models</td>
            <td>
              2023 capture of entire Local Government Area (LGA), Level of
              Detail (LOD) 0.3.
            </td>
            <td>September 2023</td>
          </tr>
        </tbody>
      </Table>
    </>
  ),
  needHelp: (
    <div>
      <p>
        To use the City of Port Phillip Development Activity Model website start
        with these steps. <br />
        <b>Step 1 - Search</b>
        <br />
        Type in your address within the “search” tool. Only properties within
        City of Port Phillip will be displayed. Once the property is selected
        your property will appear in the centre of your screen.
      </p>
      <img
        src="/images/need-help/need-help-1.png"
        alt="Searching for your address with the location search tool"
        style={{ width: "100%", height: "auto" }}
      />
      <br />
      <br />
      <p>
        <b>Step 2 – Visualise Development Activity Information </b>
        <br />
        To find out what major development permits and their status are near
        your house, click on the coloured 3D Building Model (Teal or Orange
        colour). A pop up panel to you left is displayed with key information
        about the Permit and a brief description on what the application is for.
      </p>
      <img
        src="/images/need-help/need-help-2.png"
        alt="Selecting a coloured 3D building model to view permit details"
        style={{ width: "100%", height: "auto" }}
      />
      <br />
      <br />
      <p>
        <b>Step 3 - Linking to OneCouncil Services </b>
        <br />
        To find out more about the application visit the OneCouncil Services
        link which stores the major planning descriptions and status updates or
        notes.
      </p>
      <img
        src="/images/need-help/need-help-3.png"
        alt="Opening OneCouncil Services for more application information"
        style={{ width: "100%", height: "auto" }}
      />
      <img
        src="/images/need-help/need-help-4.png"
        alt="Additional screenshot for OneCouncil application details"
        style={{ width: "100%", height: "auto" }}
      />
      <br />
      <br />
      <p>
        <b>Step 4 – Filtering Permit Visualisation </b>
        <br />
        The Permit application status is displayed on the right hand side. By
        default both approved or submitted applications will be displayed. If
        you wish to Untick either the Permit Submitted or the Permit Approved
        this will filter out your options
      </p>
      <img
        src="/images/need-help/need-help-5.png"
        alt="Permit submitted and permit approved filter options on the right"
        style={{ width: "100%", height: "auto" }}
      />
    </div>
  ),
  contact: (
    <div>
      <p>
        For further assistance, visit{" "}
        <a
          href="https://copp.t1cloud.com/T1Default/CiAnywhere/Web/COPP/RequestManagement/RequestEntryWizard?f=GP.REQUESTS&suite=PR&MasterSystem=CNCL&Requstsystem=CNCL&Requesttype=FEEDBACK&q1key=STQuestion258&q1value=FEEDBACK&G=7337bfad-5607-4662-96d5-6b4dafcdcd36"
          target="_blank"
          rel="noopener noreferrer"
        >
          My Port Phillip
        </a>
        .
      </p>
    </div>
  ),
};

export default modalContentData;
